module.exports = __webpack_public_path__ + "static/media/20240530085310_IMG_7473.31ea5f32.JPG";